import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Trip } from '../../types/trip';

interface TripState {
  trips: Trip[];
  loading: boolean;
  error: string | null;
}

const initialState: TripState = {
  trips: [],
  loading: false,
  error: null,
};

const shouldExcludeTrip = (trip: Trip): boolean => {
  const serviceName = trip.travelServiceDetail?.travelService?.name;
  const tripType = trip.tripType;
  
  return serviceName?.toUpperCase() === "OTHERS" || 
         tripType?.toUpperCase() === "OTHERS" ||
         tripType?.toUpperCase() === "OTHER";
}

export const tripSlice = createSlice({
  name: 'trips',
  initialState,
  reducers: {
    setTrips: (state, action: PayloadAction<Trip[]>) => {
      // state.trips = action.payload;
      state.trips = action.payload.filter(trip => !shouldExcludeTrip(trip));

    },
    addTrip: (state, action: PayloadAction<Trip>) => {
       if (shouldExcludeTrip(action.payload)) return;
      // Check if trip already exists
      const existingTrip = state.trips.find(
        trip => trip.tripId === action.payload.tripId || 
                trip.trip_id === action.payload.tripId ||
                trip.tripId === action.payload.tripCode ||
                trip.trip_id === action.payload.tripCode
      );
      
      if (!existingTrip) {
        state.trips.push(action.payload);
      }
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
  },
});

export const { setTrips, addTrip, setLoading, setError } = tripSlice.actions;

export default tripSlice.reducer;
